import { COPYRIGHT, EXTERNAL_LINKS } from "@/lib/externalLinks";

// Website chrome only. The desktop shell does not render this — `DeckEditor` drops it behind
// `isElectron()` and the same links live in the shell's Help menu and About panel instead.
export function Footer() {
  return (
    <footer className="mt-12 border-t border-slate-200 bg-slate-50 px-6 py-4 text-sm text-slate-600">
      <div className="mx-auto flex max-w-5xl flex-wrap items-center justify-center gap-x-6 gap-y-2">
        <span>{COPYRIGHT}</span>
        <a
          href={EXTERNAL_LINKS.privacy}
          target="_blank"
          rel="noreferrer"
          className="hover:text-slate-900"
        >
          Privacy policy
        </a>
        <a
          href={EXTERNAL_LINKS.terms}
          target="_blank"
          rel="noreferrer"
          className="hover:text-slate-900"
        >
          Terms
        </a>
        <a
          href={EXTERNAL_LINKS.home}
          target="_blank"
          rel="noreferrer"
          className="hover:text-slate-900"
        >
          Gridd Home
        </a>
      </div>
    </footer>
  );
}
